import React from 'react'
import { ReactComponent as IconFolder } from '~/assets/media/ic_folder.svg'
import './FolderMediaPreview.scss'

export const FolderMediaPreview = () => (
  <div className="folder-media-preview">
    <IconFolder />
  </div>
)
